import {Injectable} from '@angular/core';
import {WindowService} from './../window/window.service';
import {Config} from './../../config/config.service';
import {Observable, BehaviorSubject, of} from 'rxjs';
import {delay, map, scan, retryWhen} from 'rxjs/operators';

@Injectable()
export class TwitterService {
  private _window: any;
  private $subscriber: BehaviorSubject<any> = new BehaviorSubject(null);
  private maxRetryAttempts: number = 4;
  private retryDelay: number = 1500;
  private haveTwitterWidgets = false;

  constructor(private windowRef: WindowService, private _config: Config) {
  }

  private loadTwitterWidgets(d: Document, s: string, id: string): any {
      const fjs = d.getElementsByTagName(s)[0],
          t = this._window.twttr || {};
      if (d.getElementById(id)) {
          return t;
      }
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = 'https://platform.twitter.com/widgets.js';
      // Pre-existing assumption: the reference tag's parentNode exists (it's a real, attached DOM element) — not independently verified
      fjs.parentNode!.insertBefore(js, fjs);
      t._e = [];
      t.ready = function (f: any) {
          t._e.push(f);
      };
      return t;
  }

  init(): void {
    this.haveTwitterWidgets = this._config.CONFIG.haveTwitterWidgets;
    this._window = this.windowRef.nativeWindow;
    if (this.haveTwitterWidgets) {

      this._window.twttr = this.loadTwitterWidgets(document, 'script', 'twitter-wjs');
      if (undefined !== this._window.twttr) {
        this.loadWidgets();
        return this._window.twttr;
      }
    }
  }

  ready(): Observable<boolean> {
      return this.$subscriber;
  }

  private hasWidgetsLoaded(): boolean {
      return (((this._window.twttr || {}).widgets || {}).load) ? true : false;
  }

  loadWidgets() {
    const maxRetries = this.maxRetryAttempts;
    const retryDelay = this.retryDelay;

    const $widgets = of(this._window.twttr?.widgets).pipe(
      map((widgets) => {
        if (!this.hasWidgetsLoaded()) {
          throw new Error('no_twttr_script');
        }
        return widgets;
      }),
      retryWhen((errors) =>
        errors.pipe(
          scan((count, err) => {
            if (count >= maxRetries) {
              throw new Error(`Maximum retries exceeded for error: ${err.message}`);
            }
            return count + 1;
          }, 0),
          delay(retryDelay)
        )
      )
    );

    $widgets.subscribe({
      next: (widgets) => this.$subscriber.next(widgets),
      error: () => this.$subscriber.next(null)
    });
  }
}
